import * as React from 'react';

import { fromJson } from '@bufbuild/protobuf';
import {
  ContactEvent,
  ContactEventSchema,
} from '@rematter/frontend-lib-api-client/grpc/crm/v1/contact_events_pb';
import { Col, EventDetailContainer, JsonViewer } from '@rematter/ui-web';

import { ContactCreatedDetail } from './ContactCreatedDetail';
import { ContactDeletedDetail } from './ContactDeletedDetail';
import { ContactUpdatedDetail } from './ContactUpdatedDetail';

type ContactEventDetailProps = {
  payload: string;
};

export const ContactEventDetail = ({ payload }: ContactEventDetailProps) => {
  const [showJson, setShowJson] = React.useState(false);

  const event = React.useMemo((): ContactEvent | null => {
    try {
      return fromJson(ContactEventSchema, JSON.parse(payload));
    } catch {
      return null;
    }
  }, [payload]);

  if (!event) {
    return <JsonViewer data={payload} title="Raw Payload (Parse Error)" />;
  }

  const { event: inner } = event;

  const renderEventContent = () => {
    switch (inner.case) {
      case 'created':
        return <ContactCreatedDetail event={inner.value} />;
      case 'updated':
        return <ContactUpdatedDetail event={inner.value} />;
      case 'deleted':
        return <ContactDeletedDetail event={inner.value} />;
      case undefined:
        return <JsonViewer data={payload} title="Unknown Event Type" />;
    }
  };

  const getEventTitle = () => {
    switch (inner.case) {
      case 'created':
        return 'Contact Created';
      case 'updated':
        return 'Contact Updated';
      case 'deleted':
        return 'Contact Deleted';
      case undefined:
        return 'Unknown Event';
    }
  };

  return (
    <Col className="@ContactEventDetail flex-1">
      <EventDetailContainer
        title={getEventTitle()}
        showJson={showJson}
        onToggleJson={() => setShowJson(!showJson)}
        jsonContent={payload}
      >
        {renderEventContent()}
      </EventDetailContainer>
    </Col>
  );
};
